import { useCallback, useState, useEffect } from 'react';
import { ToggleSwitch } from 'flowbite-react';
import 'twin.macro';

import { useWorkersService } from '@restworld/data-services';
import { useQueryClient } from '@tanstack/react-query';

const SaveResearchSubscribeToggle = ({
  defaultChecked,
  saveResearchId,
  onLoading,
}: {
  defaultChecked: boolean;
  saveResearchId: number;
  onLoading: (loading: boolean) => void;
}) => {
  const [checked, setChecked] = useState(false);
  const workerServices = useWorkersService();
  const queryClient = useQueryClient();

  const handleToggle = useCallback(async () => {
    setChecked(!checked);
    try {
      onLoading(true);
      await workerServices.updateSavedResearch({
        id: saveResearchId,
        enabled: !defaultChecked,
      });
      queryClient.invalidateQueries({
        queryKey: ['listSaveResearch'],
      });
    } catch (error) {
      console.error(`Failed to update saved research ${saveResearchId}`, error);
    } finally {
      onLoading(false);
    }
  }, [checked, onLoading, workerServices, saveResearchId, defaultChecked, queryClient]);

  useEffect(() => {
    setChecked(defaultChecked);
  }, [defaultChecked]);

  return (
    <div tw="flex flex-col justify-between items-center">
      <ToggleSwitch checked={checked} label="" onChange={handleToggle} color="purple" />
    </div>
  );
};

export default SaveResearchSubscribeToggle;
